import * as React from 'react';
/**
 *
 * Original name: person circle
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A319
 *
 */
export const PersonCirclePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M32 8C16.523 8 8 16.523 8 32s8.523 24 24 24 24-8.523 24-24S47.477 8 32 8Zm0 44c-7.721 0-13.212-2.295-16.467-6.814A7.949 7.949 0 0 1 23 40h18a7.95 7.95 0 0 1 7.467 5.186C45.212 49.705 39.722 52 32 52Zm-6-24c0-5.309 2.019-8 6-8s6 2.691 6 8-2.019 8-6 8-6-2.691-6-8Zm15 8h-1.044c1.45-2.41 2.16-5.19 2.044-8 0-7.514-3.738-12-10-12-6.262 0-10 4.486-10 12-.116 2.81.595 5.59 2.044 8H23a11.95 11.95 0 0 0-9.676 4.89A27.17 27.17 0 0 1 12 32c0-13.271 6.729-20 20-20s20 6.729 20 20a27.17 27.17 0 0 1-1.324 8.89A11.95 11.95 0 0 0 41 36Z", fill: "currentColor" })));
